<div class="propero-home propero-product-detail" *ngIf="feature as f">
  <section class="ph-section ph-products-layout ph-product-detail-layout">
    <div class="ph-container ph-products-layout__inner">
      <app-products-nav mode="detail" [activeId]="f.id"></app-products-nav>

      <div class="ph-product-detail-main">
        <section class="ph-product-detail-hero">
          <div
            class="ph-product-detail-hero__grid"
            [class.ph-product-detail-hero__grid--copy-only]="hasAdminVisuals(f)">
            <div class="ph-product-detail-hero__copy">
              <div class="ph-product-feature__icon" aria-hidden="true">
                <i class="lni" [ngClass]="f.icon"></i>
              </div>
              <h1 class="ph-product-detail-hero__title">{{ f.titleKey | translate }}</h1>
              <p class="ph-product-detail-hero__lead">{{ f.leadKey | translate }}</p>
              <p class="ph-product-detail-hero__intro">{{ f.detailIntroKey | translate }}</p>
              <div class="ph-product-detail-hero__actions">
                <a [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand">
                  {{ 'PRODUCTS.CTA_DEMO_ADMIN' | translate }}
                </a>
                <a [href]="assistantLoginHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--outline">
                  {{ 'PRODUCTS.CTA_DEMO_RENTER' | translate }}
                </a>
              </div>
            </div>

            <figure *ngIf="!hasAdminVisuals(f)" class="ph-product-detail-hero__media">
              <app-product-screenshot
                [src]="f.screenshot"
                [altKey]="f.screenshotAltKey"
                (imageError)="onScreenshotError($event)">
              </app-product-screenshot>
            </figure>
          </div>
        </section>

        <div class="ph-product-detail-sections">
          <article
            *ngFor="let section of detailSections; let si = index; trackBy: trackBySectionIndex"
            class="ph-product-detail-section"
            [class.ph-product-detail-section--admin]="section.portal === 'admin'"
            [class.ph-product-detail-section--renter]="section.portal === 'renter'">
            <span
              *ngIf="section.portal"
              class="ph-product-detail-section__portal"
              [class.ph-product-detail-section__portal--admin]="section.portal === 'admin'"
              [class.ph-product-detail-section__portal--renter]="section.portal === 'renter'">
              <i class="lni" [ngClass]="section.portal === 'admin' ? 'lni-protection' : 'lni-user'" aria-hidden="true"></i>
              {{ (section.portal === 'admin' ? 'PRODUCTS.PORTAL_ADMIN' : 'PRODUCTS.PORTAL_RENTER') | translate }}
            </span>
            <h2 class="ph-product-detail-section__title">{{ section.titleKey | translate }}</h2>
            <p class="ph-product-detail-section__intro">{{ section.introKey | translate }}</p>

            <div
              *ngIf="section.portal === 'admin' && f.adminVisualBlocks?.length"
              class="ph-product-detail-visuals">
              <article
                *ngFor="let block of f.adminVisualBlocks; let vi = index; trackBy: trackByVisualIndex"
                class="ph-product-detail-visual"
                [class.ph-product-detail-visual--reverse]="vi % 2 === 1">
                <div class="ph-product-detail-visual__copy">
                  <h3 class="ph-product-detail-visual__title">{{ block.titleKey | translate }}</h3>
                  <p class="ph-product-detail-visual__text">{{ block.textKey | translate }}</p>
                </div>
                <figure class="ph-product-detail-visual__media">
                  <app-product-screenshot
                    [src]="block.src"
                    [altKey]="block.titleKey"
                    [slides]="getScreenshotSlides(f)"
                    [slideIndex]="vi"
                    (imageError)="onScreenshotError($event)">
                  </app-product-screenshot>
                </figure>
              </article>
            </div>

            <div *ngIf="section.items.length" class="ph-product-detail-items">
              <div
                *ngFor="let item of section.items; let ii = index; trackBy: trackByItemIndex"
                class="ph-product-detail-item">
                <h3 class="ph-product-detail-item__title">{{ item.titleKey | translate }}</h3>
                <p class="ph-product-detail-item__text">{{ item.textKey | translate }}</p>
              </div>
            </div>
          </article>
        </div>

        <nav class="ph-product-detail-nav" aria-label="Navigare module">
          <a
            *ngIf="prevFeature as prev"
            [routerLink]="['/products', prev.id]"
            class="ph-product-detail-nav__link ph-product-detail-nav__link--prev">
            <span class="ph-product-detail-nav__label">{{ 'PRODUCTS.PREV' | translate }}</span>
            <span class="ph-product-detail-nav__title">{{ prev.titleKey | translate }}</span>
          </a>
          <span *ngIf="!prevFeature" class="ph-product-detail-nav__spacer"></span>

          <a routerLink="/products" class="ph-product-detail-nav__hub">
            {{ 'PRODUCTS.NAV_TITLE' | translate }}
          </a>

          <a
            *ngIf="nextFeature as next"
            [routerLink]="['/products', next.id]"
            class="ph-product-detail-nav__link ph-product-detail-nav__link--next">
            <span class="ph-product-detail-nav__label">{{ 'PRODUCTS.NEXT' | translate }}</span>
            <span class="ph-product-detail-nav__title">{{ next.titleKey | translate }}</span>
          </a>
          <span *ngIf="!nextFeature" class="ph-product-detail-nav__spacer"></span>
        </nav>
      </div>
    </div>
  </section>
</div>
